/* eslint-disable react/jsx-no-useless-fragment */
import _ from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import { Icon, Label, Table } from "../..";
import TableRichModal from "./TableRichModal";
import TableRichPopup from "./TableRichPopup";
import ModalConfirm from "./ModalConfirm";

/**
 * Table Rich Cell
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var TableRichCell = function TableRichCell(props) {
  var cellKey = props.cellKey,
    item = props.item,
    columns = props.columns,
    onSave = props.onSave,
    mountNode = props.mountNode;
  var _useState = useState(false),
    displayCell = _useState[0],
    setDisplayCell = _useState[1];
  var _useState2 = useState(false),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    updating = _useState3[0],
    setUpdating = _useState3[1];
  var _useState4 = useState(false),
    modalConfirmShow = _useState4[0],
    setModalConfirmShow = _useState4[1];
  var handleMouseEnter = function handleMouseEnter(cellId) {
    return setDisplayCell(cellId);
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (!isOpen) {
      setDisplayCell(null);
    }
  };
  var closeModal = function closeModal(avecVerif) {
    if (avecVerif && updating) {
      setModalConfirmShow(true);
    } else {
      setDisplayCell(null);
      setIsOpen(false);
    }
  };
  var closePopup = function closePopup() {
    setDisplayCell(null);
    setIsOpen(false);
  };
  var handleOpen = function handleOpen() {
    setIsOpen(true);
  };
  var handleCloseConfirm = function handleCloseConfirm() {
    setModalConfirmShow(false);
    closeModal();
  };
  var renderComp = function renderComp(comp, KeyTmp, label, index) {
    if (!_.isNil(comp.popup) && comp.popup) {
      return /*#__PURE__*/_jsx(TableRichPopup, {
        labelColonne: label,
        indexColonne: index,
        mountNode: mountNode,
        comp: Object.assign({}, comp),
        item: Object.assign({}, item),
        isVisible: function isVisible() {
          return displayCell;
        },
        closePopup: closePopup,
        onClose: closePopup,
        onSave: onSave,
        onOpen: handleOpen
      }, KeyTmp);
    }
    if (!_.isNil(comp.modal) && comp.modal) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(TableRichModal, {
          labelColonne: label,
          indexColonne: index,
          mountNode: mountNode,
          comp: Object.assign({}, comp),
          item: Object.assign({}, item),
          isVisible: function isVisible() {
            return displayCell;
          },
          closeModal: closeModal,
          onClose: closeModal,
          onSave: onSave,
          onOpen: handleOpen,
          setUpdating: setUpdating
        }, KeyTmp), /*#__PURE__*/_jsx(ModalConfirm, {
          onCancel: function onCancel() {
            return setModalConfirmShow(false);
          },
          onClose: function onClose() {
            return handleCloseConfirm();
          },
          onDraft: function onDraft() {
            comp.handleDraft();
            handleCloseConfirm();
          },
          open: modalConfirmShow
        })]
      });
    }
    return /*#__PURE__*/_jsx(comp.component, Object.assign({}, item.props, {
      onSave: onSave
    }));
  };
  renderComp.handledProps = [];
  var componentsAreVisible = function componentsAreVisible(itemTmp, col) {
    if (_.isNil(itemTmp.props) || _.isNil(itemTmp.props.iconDisabled)) {
      return true;
    }
    var iconName = '';
    var _loop = function _loop() {
      var component = col.components[m];
      if (_.findIndex(itemTmp.props.iconDisabled, function (i) {
        return i.name === component.icon;
      }) !== -1) {
        iconName = component.icon;
      }
    };
    for (var m = 0; m < col.components.length; m += 1) {
      _loop();
    }
    if (_.findIndex(itemTmp.props.iconDisabled, function (i) {
      return i.name === 'all' && i.column === col.item;
    }) !== -1 || _.findIndex(itemTmp.props.iconDisabled, function (i) {
      return i.name === iconName && i.column === 'all';
    }) !== -1 && col.components.length <= 1 || _.findIndex(itemTmp.props.iconDisabled, function (i) {
      return i.name === 'all' && i.column === 'all';
    }) !== -1 || _.findIndex(itemTmp.props.iconDisabled, function (i) {
      return i === 'all';
    }) !== -1 || _.findIndex(itemTmp.props.iconDisabled, function (i) {
      return i.name === iconName && i.column === col.item;
    }) !== -1 && col.components.length <= 1) {
      return false;
    }
    return true;
  };
  return columns.map(function (col, i) {
    var cellKeyTmp = "cell_" + cellKey + "_" + i;
    if (_.has(col, 'icon')) {
      return /*#__PURE__*/_jsx(Table.Cell, {
        className: col.displayOnHover ? 'onHover' : '',
        width: col.width,
        children: /*#__PURE__*/_jsx(Icon, {
          size: "small",
          name: col.icon
        })
      }, cellKeyTmp);
    }
    if (_.has(col, 'components') && componentsAreVisible(item, col)) {
      var widthComp = _.has(col, 'componentsGridWidth') ? col.componentsGridWidth : 6;
      return /*#__PURE__*/_jsx(Table.Cell, {
        className: col.displayOnHover ? 'onHover' : '',
        width: col.width,
        children: /*#__PURE__*/_jsxs(Grid, {
          className: "componentGrid",
          columns: displayCell === cellKeyTmp ? 2 : 1,
          children: [/*#__PURE__*/_jsx(Grid.Column, {
            width: displayCell === cellKeyTmp ? 16 - widthComp : 16,
            onMouseEnter: function onMouseEnter() {
              return handleMouseEnter(cellKeyTmp);
            },
            onMouseLeave: function onMouseLeave() {
              return handleMouseLeave();
            },
            children: /*#__PURE__*/_jsx("div", {
              className: "componentContentColumnItem",
              title: item[col.item],
              children: item[col.item]
            })
          }), displayCell === cellKeyTmp ? /*#__PURE__*/_jsx(Grid.Column, {
            width: widthComp,
            className: "componentContentColumnComp",
            onMouseEnter: function onMouseEnter() {
              return handleMouseEnter(cellKeyTmp);
            },
            onMouseLeave: function onMouseLeave() {
              return handleMouseLeave();
            },
            style: {
              paddingLeft: 0,
              paddingRight: 0
            },
            children: col.components.map(function (comp, iComp) {
              var KeyTmp = "popup_" + iComp;
              var iconName = '';
              var columnName = '';
              if (item.props && item.props.iconDisabled) {
                for (var m = 0; m < item.props.iconDisabled.length; m += 1) {
                  var iconDisabled = item.props.iconDisabled[m];
                  iconName = iconDisabled.name;
                  columnName = iconDisabled.column;
                }
              }
              if (item.props && item.props.iconDisabled && (_.findIndex(item.props.iconDisabled, function (icon) {
                return icon.name === comp.icon && (icon.column === col.item || icon.column === 'all');
              }) !== -1 || iconName === 'all' && columnName === col.item || iconName === comp.icon && columnName === 'all')) {
                return /*#__PURE__*/_jsx(_Fragment, {});
              }
              return renderComp(comp, KeyTmp, col.label, i);
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {})]
        })
      }, cellKeyTmp);
    }
    return /*#__PURE__*/_jsxs(Table.Cell, {
      className: col.displayOnHover ? 'onHover' : '',
      textAlign: col.columnAlign,
      width: col.width,
      children: [/*#__PURE__*/_jsx("div", {
        className: /* eslint-disable-next-line no-nested-ternary */
        col.disableEllipsis ? 'itemTextNoEllipsis' : col.isDropDown ? 'itemDropDown' : 'itemText',
        title: item[col.item],
        children: item[col.item]
      }), col.displayRequired && item.required ? /*#__PURE__*/_jsx(Label, {
        style: {
          verticalAlign: 'super',
          color: 'red',
          backgroundColor: 'transparent',
          padding: 0
        },
        children: "*"
      }) : null]
    }, cellKeyTmp);
  });
};
TableRichCell.handledProps = ["cellKey", "columns", "item", "items", "mountNode"];
TableRichCell.propTypes = {
  cellKey: PropTypes.integer,
  mountNode: PropTypes.node,
  columns: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object])),
  items: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]))
};
TableRichCell.defaultProps = {
  cellKey: 0,
  item: {},
  // mountNode: null,
  columns: []
};
export default TableRichCell;